<dialog
  mibDialogInitialFocus
  class="mib-dialog flex flex-col gap-6"
  [class.mib-modal-dark]="isDark"
  [class.dark]="isDark"
  aria-modal="true"
  [attr.aria-labelledby]="titleId">
  <header class="flex items-start justify-between gap-3">
    <h3 [id]="titleId" class="text-xl">{{ data.title }}</h3>
    @if (data.showCloseButton !== false) {
      <button
        mibButton
        data-mib-dialog-close
        theme="secondary"
        size="sm"
        [attr.aria-label]="data.closeLabel || 'Close'"
        (click)="dialogRef.close(false)">
        <svg mib-icon name="x"></svg>
      </button>
    }
  </header>
  @if (data.description) {
    <div [class]="isDark ? 'text-gray-300' : 'text-gray-600'">{{ data.description }}</div>
  }
  @if (data.contentTemplate) {
    <div>
      <ng-container [ngTemplateOutlet]="data.contentTemplate"></ng-container>
    </div>
  }
  <footer class="flex gap-3 justify-end">
    <button mibButton theme="secondary" (click)="dialogRef.close(false)">{{ data.cancelLabel || 'Cancel' }}</button>
    <button mibButton [theme]="data.theme || 'primary'" (click)="dialogRef.close(true)">{{ data.confirmLabel }}</button>
  </footer>
</dialog>
